import React from 'react';
import { motion } from 'framer-motion';
export function MechanismReveal() {
  return <section className="w-full py-16 md:py-24 bg-[#F5F2E6]/80" data-id="element-71">
      <div className="max-w-6xl mx-auto px-6" data-id="element-72">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-73">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-74">
            <h2 className="font-lora text-3xl md:text-4xl font-bold text-charcoal mb-6" data-id="element-75">
              El Verdadero Origen de Tu Ansiedad
            </h2>

            <div className="font-inter text-lg text-charcoal/90 leading-relaxed space-y-6" data-id="element-76">
              <p data-id="element-77">
                El verdadero origen de la ansiedad crónica no está en tus
                pensamientos. Está en un cable biológico llamado{' '}
                <span className="font-semibold text-sage" data-id="element-78">Nervio Vago</span>.
              </p>

              <p data-id="element-79">
                Este nervio es el director de orquesta de tu sistema nervioso
                autónomo. Cuando funciona bien, mantiene el equilibrio entre el
                modo "alerta" y el modo "calma". Cuando está dysregulado (por
                estrés crónico, falta de sueño, trauma o simplemente el ritmo de
                vida moderno), tu cuerpo se queda atascado en modo alerta aunque
                no haya ningún peligro real.
              </p>

              <p className="font-semibold" data-id="element-80">
                El Anclaje Fisiológico Inmediato (AFI) es el protocolo que
                activa directamente este nervio a través de tres vías de acceso
                que siempre tienes disponibles: la respiración, el tacto y la
                visión.
              </p>

              <p className="text-sage font-semibold" data-id="element-81">
                No necesitas creer en él para que funcione. Solo necesitas
                ejecutarlo.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-82">
            <img src="https://cdn.magicpatterns.com/uploads/7JUZoPyiVhKNSrDYMvMVHM/heylloyd-image-1775843939839.png" alt="Calmante Natural Ansiedad 24h en múltiples dispositivos" className="w-full rounded-2xl shadow-xl" data-id="element-83" />
          </motion.div>
        </div>
      </div>
    </section>;
}